export default __webpack_public_path__ + "static/media/logo.4adc3d48.png";